import { InsightsGeneratorHelper } from '../insights/insights-generator.helper';

export class MarkdownPayloadHelper {
  static storeTableAsMarkdown(component: any): void {
    if (component.tableOutputComponent) {
      const markdown = component.tableOutputComponent.extractMarkdownTable();
      if (markdown) {
        component.insights_payload = markdown;
      }
    } else {
      console.warn('[Crosstab Markdown] tableOutputComponent is not initialized or rendered yet.');
    }
  }

  static buildSnapshotMarkdown(component: any): void {
    try {
      const md = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(
        component.filteredWidgetData
      );
      component.snapshotinsights_payload = md;

      // Handle trendline data if available
      if (component.filteredWidgetData?.trendline_response) {
        const trendMd = InsightsGeneratorHelper.buildTrendSnapshotMarkdownFromWidget(
          component.filteredWidgetData
        );
        component.snapshotinsights_trend_payload = trendMd;
      }
    } catch (err) {
      console.error('[Snapshot Markdown] Error:', err);
    }
  }

  static buildTrendSnapshotMarkdown(component: any): void {
    try {
      const md = InsightsGeneratorHelper.buildTrendSnapshotMarkdownFromWidget(
        component.filteredWidgetData
      );
      component.snapshotinsights_trend_payload = md;
    } catch (err) {
      console.error('[Trend Snapshot Markdown] Error:', err);
    }
  }

  static async buildMarkdownPayload(component: any, isTrend: boolean = false): Promise<any> {
    try {
      const token = await component.getBearerToken();
      const isSnapshot = component.mcode === 1;

      let markdown = isSnapshot
        ? (isTrend ? component.snapshotinsights_trend_payload : component.snapshotinsights_payload)
        : component.insights_payload;

      // Fallback: If markdown is still null, try to generate it directly from raw data
      if (!markdown) {
        if (isSnapshot && component.filteredWidgetData) {
          markdown = isTrend
            ? InsightsGeneratorHelper.buildTrendSnapshotMarkdownFromWidget(component.filteredWidgetData)
            : InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(component.filteredWidgetData);
          
          if (isTrend) component.snapshotinsights_trend_payload = markdown;
          else component.snapshotinsights_payload = markdown;
          
        } else if (!isSnapshot && component.CrossTabOutPutData?.length > 0) {
          markdown = InsightsGeneratorHelper.buildCrosstabMarkdownForAPI(
            component.CrossTabOutPutData,
            component.isTotalBase,
            component.selectedWeight
          );
          component.insights_payload = markdown;
        }
      }

      const basePayload: any = {
        client_name: component.selected_client || component.landingdata?.client_code || '',
        study: component.selected_study || component.landingdata?.study || '',
        session_id: component.guidChatId,
        bearer_token: token,
        markdown: markdown,
        mcode: component.mcode,
        query: component.inputValue,
        debug_mode: false
      };

      if (isSnapshot) {
        basePayload.selected_doc_id = component.chatPayload?.selected_doc_id || component.promptData?.selected_doc_id || '';

        if (component.filteredWidgetData) {
          basePayload['widget_details'] = {
            widget_name: component.filteredWidgetData.widget_name || '',
            widget_id: component.filteredWidgetID || '',
            widgetchart_name: component.filteredWidgetData.widgetchart_name || '',
            Snapshot_Name: component.Snapshotdataforexport?.snapshotName || '',
            Snapshot_Type: component._configService.selectedSnapshotType || '',
            Section: component.selectedSection
          };
        }
      }


      return basePayload;

    } catch (err) {
      console.error('[Markdown Payload] Error building payload:', err);
      return null;
    }
  }
}
